import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import UserLayout from '@/views/layouts/UserLayout'
import AuthLayout from '@/views/layouts/AuthLayout.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    component: UserLayout,
    children: [{
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        dashboard: true
      }
    }],
  },
  {
    path: '/login',
    component: AuthLayout,
    children: [{
      path: '',
      name: 'Login',
      component: () => import('@/views/auth/Login'),
      meta: {
        login: true
      }
    },
    {
      path: 'discord',
      name: 'discordLoginSSO',
      component: () => import('@/views/discordLoginSSO'),
      meta: {
        login: true
      }
    },],
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
